import useSSO from '../useSSO'
import buildLoginURL from '../../utils/buildLoginURL'

function useLogin (params = {}) {
  const { loginUrl, apiKey = {} } = useSSO()

  const query = Object.keys(params)
    .map(key => key + '=' + params[key])
    .join('&')
  const encodedQuery = encodeURI(query)
  const url = buildLoginURL(loginUrl, apiKey, encodedQuery)

  function onLoginClick () {
    if (url) {
      window.location.assign(url)
    }
  }

  return { onLoginClick }
}

export default useLogin
